import { Box, Container } from '@material-ui/core'
import { useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import FilterSection from 'src/components/common/filterSection'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteBannerById } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetBannerTableColumns } from 'src/util/columns'

import AddEditBannerList from '../components/banner/AddEditBanner'

const BannerList = () => {
  const dispatch = useDispatch()
  const [recordToEdit, setRecordToEdit] = useState()
  const [searchText, setSearchText] = useState(null)

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'banners',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
  })

  const onDeleteRow = async record => {
    await dispatch(DeleteBannerById(record))
    refetch()
  }

  const columns = useMemo(() => GetBannerTableColumns(), [])

  return (
    <>
      <Helmet>
        <title>Banners | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* addButton filters & search section  */}
          <FilterSection
            type="Banner"
            path="Banners"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
          />

          {/* Banner data list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              name="Banner"
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              data={data}
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {/* Create & Update banner  */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={`${recordToEdit?.id ? "Update" : "Create"} Banner`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="md"
          >
            <Box>
              <AddEditBannerList
                selectedRow={recordToEdit}
                refetch={refetch}
                toggleDrawer={() => setRecordToEdit()}
              />
            </Box>
          </AddUpdateDialog>

        </Container>
      </Box>
    </>
  )
}

export default BannerList
